"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  init: function init() {
    // JavaScript to be fired on the about us page
  }
};


// WEBPACK FOOTER //
// ./scripts/routes/about.js